import { useTranslation } from 'react-i18next';
import { OfferFlame, OfferPopLines, OfferTicketIcon } from './OfferArt';
import { OfferMarks } from './OfferTicket';
import { formatRewardValue, offerReward, offerRule, type CampaignOffer } from './campaignOfferCopy';
import { useOfferMotion, useRevealNumber } from './offerMotion';
import './campaignOffer.css';

/** The popup's banner for its best offer: ticket and flame art, "Hot offer", the figure. */
export default function OfferHero({ offer, now }: { offer: CampaignOffer; now: number }) {
  const { t } = useTranslation();
  const motion = useOfferMotion();
  const shown = useRevealNumber(offer.bonusValue, motion);
  const reward = offerReward(offer, t);

  return (
    <div className="offer-hero" data-testid="campaign-bonus-hero">
      <div className="offer-hero__art">
        <OfferTicketIcon className="offer-hero__ticket" />
        <span className="offer-hero__flame">
          <OfferFlame className="size-7" />
        </span>
        <OfferPopLines />
      </div>
      <span className="offer-eyebrow">{t('campaignBonus.ribbon', 'Hot offer')}</span>
      <p className="m-0 flex flex-col items-center gap-1">
        <span className="offer-reward offer-reward--hero" aria-hidden>
          {formatRewardValue(offer, shown)}
        </span>
        <span className="font-ui text-body font-semibold text-primary" aria-hidden>
          {reward.caption}
        </span>
        <span className="sr-only">{`${reward.value} ${reward.caption}`}</span>
      </p>
      <p className="m-0 mt-1 font-display k-heading text-title text-primary">{offer.playerMessage}</p>
      <p className="m-0 font-ui text-small text-secondary">{offerRule(offer, t)}</p>
      <div className="mt-1 flex flex-wrap justify-center gap-1.5">
        <OfferMarks offer={offer} now={now} />
      </div>
    </div>
  );
}
